import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import createBookWithId from "../../utils/createBookWithId";
import { setError } from "./errorSlice";

const initialState = {
  books: [],
  isLoadingViaAPI: false,
};

export const fetchBook = createAsyncThunk(
  "books/fetchBook",
  async (url, thunkAPI) => {
    try {
      const res = await axios.get(url);
      return res.data;
    } catch (error) {
      thunkAPI.dispatch(setError(error.message));
      
      // throw error; // вручную выбрасываем Ошибку т.к. используем try catach и при ошбике Promise будет fulfilled а не rejected (т.е. ошибки не будет) соответственно чтобы addCase, который ниже, сработал правильно можно выбросить ошибку вручную
      return thunkAPI.rejectWithValue(error); // можно ещё так вернуть ошибку    
    }
  }
);

const booksSlice = createSlice({
  name: "books",
  initialState: initialState,
  reducers: {
    addBook: (state, action) => {
      state.books.push(action.payload);
    },
    deleteBook: (state, action) => {
      return {...state, books: state.books.filter((book) => book.id !== action.payload)}
    },
    toggleFavoriteBook: (state, action) => {
      // Можно мутировать существующий массив благодаря встроенной библиотеке immer
      state.books.forEach((book) => {
        if (book.id === action.payload) {
          book.isFavorite = !book.isFavorite;
        }
      })
    },
  },
  // Вариант 1
  extraReducers: {
    [fetchBook.pending]: (state, action) => {
      state.isLoadingViaAPI = true;
    },
    [fetchBook.fulfilled]: (state, action) => {
      state.isLoadingViaAPI = false;
      if (action.payload?.title && action.payload?.author) {
        state.books.push(createBookWithId(action.payload, "API"));
      }
    },
    [fetchBook.rejected]: (state, action) => {
      state.isLoadingViaAPI = false;
    }
    // Вариант 2
    // extraReducers: (builder) => {
    //   builder.addCase(fetchBook.pending, (state, action) => {
    //     state.isLoadingViaAPI = true;
    //   });

    //   builder.addCase(fetchBook.fulfilled, (state, action) => {
    //     state.isLoadingViaAPI = false;
    //     if (action.payload.title && action.payload.author) {
    //       state.books.push(createBookWithId(action.payload, "API"));
    //     }
    //   });

    //   builder.addCase(fetchBook.rejected, (state, action) => {
    //     state.isLoadingViaAPI = false;
    //   })


    // Не можем так сделать т.к. тогда эта функция (редьюсера) не будет чистой из-за того что мы берем setError - который относится к другому Slice
    // builder.addCase(fetchBook.rejected, (state, action) => {
    //   dispatch(setError('Error'))
    // })
  },
});


export const { addBook, deleteBook, toggleFavoriteBook } = booksSlice.actions;
export const selectBooks = (state) => state.books.books;
export const selectIsLoadingViaAPI = (state) => state.books.isLoadingViaAPI;

export default booksSlice.reducer;
